"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _ActionBar = require("./ActionBar");

const HeadlineItem = (0, _styledComponents.default)(_blocks.DisplaySmall)`
  display: inline-flex;
  align-items: center;
  font-weight: ${_blocks.fontWeight.bold};
  margin-right: ${_blocks.spacing.default};
  color: ${_blocks.color.theme.typography.ink};

  &:last-of-type {
    margin-right: 0;
  }

  svg {
    margin-right: ${_blocks.spacing.extraTight};
  }
`;

const InfoText = ({
  active: numActions,
  status,
  closedOnStartDate,
  numberOfSelectedSites: numSelectedSites
}) => {
  const showClosed = status === 'closed';
  const getClosedOnStartDateLabel = React.useCallback((showClosed, closedOnStartDate) => {
    if (!showClosed || closedOnStartDate === undefined) return null;
    return (0, _ActionBar.getClosedOptions)(_core.i18n).find(option => option.value === closedOnStartDate).label;
  }, [numActions, status, closedOnStartDate]);
  return /*#__PURE__*/React.createElement(_blocks.Thirds, null, /*#__PURE__*/React.createElement(_blocks.Center, null, status === 'closed' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadlineItem, null, /*#__PURE__*/React.createElement(_blocks.SiteOutline, null), /*#__PURE__*/React.createElement(_react.Trans, {
    id: "{numSelectedSites, plural, one {# Site} other {# Sites}}",
    values: {
      numSelectedSites: numSelectedSites
    }
  })), /*#__PURE__*/React.createElement(HeadlineItem, null, /*#__PURE__*/React.createElement(_blocks.ActionListOutline, null), /*#__PURE__*/React.createElement(_react.Trans, {
    id: "{numActions, plural, one {# Closed Action} other {# Closed Actions}}",
    values: {
      numActions: numActions
    }
  })), /*#__PURE__*/React.createElement(HeadlineItem, null, /*#__PURE__*/React.createElement(_blocks.CalendarListOutline, null), ' ', getClosedOnStartDateLabel(showClosed, closedOnStartDate))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadlineItem, null, /*#__PURE__*/React.createElement(_blocks.SiteOutline, null), /*#__PURE__*/React.createElement(_react.Trans, {
    id: "{numSelectedSites, plural, one {# Site} other {# Sites}}",
    values: {
      numSelectedSites: numSelectedSites
    }
  })), /*#__PURE__*/React.createElement(HeadlineItem, null, /*#__PURE__*/React.createElement(_blocks.ActionListOutline, null), /*#__PURE__*/React.createElement(_react.Trans, {
    id: "{numActions, plural, one {# Open Action} other {# Open Actions}}",
    values: {
      numActions: numActions
    }
  })))));
};

var _default = InfoText;
exports.default = _default;
module.exports = exports.default;